import { useState } from "react";
import { Button, Form, Input, notification } from "antd";
import { Row, Col } from "react-bootstrap";
import { BiErrorCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { login } from "../../redux/slices/userSlice";
import API from "../../config/API";
import { POST } from "../../utils/apiCalls";
import React from "react";
import SuccessModal from "../../components/successModal";

function EmailLogin() {
  const { t } = useTranslation();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [notificationApi, contextHolder] = notification.useNotification();
  const [successmodal, setSuccessmodal] = useState(false);
  const LoginEmail = async (values: any) => {
    try {
      setIsLoading(true);
      let url = API.LOGIN_EMAIL;
      let body = {
        email: values.username,
        password: values.password,
      };
      var loginRes: any = await POST(url, body);
      if (loginRes.status) {
        notificationApi.success({ message: `${t("Login_Sucessful")}` });
        setSuccessmodal(true);
        setTimeout(() => {
          dispatch(login(loginRes));
        }, 2000);
        setIsLoading(false);
      } else {
        setError(loginRes.message);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      setError(`${t("Something_went_wrong")}`);
    }
  };

  return (
    <div>
      {contextHolder}
      <div className="LoginScreen-txt2">{t("sign_in_desc3")}</div>
      <br />
      <Form onFinish={LoginEmail}>
        <Form.Item name={"username"} rules={[{ required: true, message: "" }]}>
          <Input size="large" placeholder={t("Enter_your_Email")} />
        </Form.Item>
        <Form.Item name={"password"} rules={[{ required: true, message: "" }]}>
          <Input.Password size="large" placeholder={t("Enter_Password")} />
        </Form.Item>
        {error ? (
          <div className="LoginScreen-errortxt">
            <BiErrorCircle />
            &nbsp;
            {error} {t("Try_again")}
          </div>
        ) : null}
        <Row>
          <Col sm={6} xs={12}>
            <div
              className="LoginScreen-txt3"
              onClick={() => navigation("/forgott")}
            >
              {t("Forgot_password?")}
            </div>
          </Col>
          <Col sm={6} xs={12}>
            <Button
              loading={isLoading}
              block
              size="large"
              type="primary"
              htmlType="submit"
              style={{ height: 45 }}
            >
              {t("Login")}
            </Button>
          </Col>
        </Row>
      </Form>
      <hr />
      {successmodal ? (
        <SuccessModal
          visible={successmodal}
          onCancel={() => setSuccessmodal(false)}
          title="Success"
          body="Logged in successfully! Welcome back!"
          onButtonClick={() => setSuccessmodal(false)}
          buttonText="Start Purchasing"
        />
      ) : null}
    </div>
  );
}
export default EmailLogin;
